// @flow

import * as React from "react";

type PropsType = {
    className?: string,
    selected: boolean,
    name: string,
    options: Array,
    disabledOptions: Array,
    infoBtn?: {
        label: string,
        onClick: Function,
    },
    onChange: Function,
};

function AttributeRadio(props: PropsType): React.Node {
    const classList = ["attribute-radio"];

    if (props.className) {
        classList.push(props.className);
    }

    if (props.error) {
        classList.push("has-error");
    }

    return (
        <div className={classList.join(" ")}>
            <label className="attribute-radio__label">
                {props.name}

                {props.infoBtn ? (
                    <button
                        className="attribute-radio__label__btn"
                        type="button"
                        onClick={props.infoBtn.onClick}
                    >
                        {props.infoBtn.label}
                    </button>
                ) : null}
            </label>

            {props.error ? (
                <div className="attribute-radio__error">{props.error}</div>
            ) : null}

            <div className="attribute-radio__options">
                {props.options.map((option, index) => {
                    return (
                        <label key={index} className="attribute-radio__item">
                            <input
                                type="radio"
                                name={props.name}
                                value={option}
                                checked={
                                    props.selected === option.toLowerCase()
                                }
                                onChange={props.onChange}
                                disabled={props.disabledOptions.includes(
                                    option
                                )}
                            />
                            <div className="attribute-radio__item__inner">
                                {option}
                            </div>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}

export default AttributeRadio;
